// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ##### Code for CounterHeader and CountryHeader2 #####*/

/* ##### Header  --> Start #####*/
.header {
  height: 60px;
  width: 100%;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: #122b4f;
  background-color: #203864;
  z-index: 3;
  transition: 0.3s ease-out;
}
.header > :first-child {
  display: flex;
  align-items: center;
  justify-content: center;
}
.header > :first-child > img {
  max-height: 8vmin;
  cursor: pointer;
}
.header > :nth-child(2) {
  font-size: 3vmin;
  font-weight: 900;
  color: #fff;
  width: 40%;
  text-align: center;
  padding: 1vmax;
}

.header > :last-child {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8vmax;
}

.header > :last-child > span {
  text-align: center;
  font-weight: 900;
  font-size: 2.2vmin;
  cursor: pointer;
  transition: 0.1s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.5vmax;
  color: #fff;
  white-space: nowrap;
}
.header > :last-child > span > svg {
  padding-right: 0.5vmin;
}

.header > :last-child > span:hover {
  color: #ed7d31 !important;
}

.dropdown {
  padding: 0 0.2vmax;
}

.bar {
  color: #fff;
  display: none;
  font-size: 1.8rem;
  height: 40px ;
  width: 40px;
  text-align: center;
}
.bar i{
  cursor: pointer;
}

.bar-icon {
  /* margin-left: 130%; */
  animation: animate_bar_icon 0.5s linear;
  transition: 0.3s ease-in-out;
}

.xmark-icon {
  transition: 0.3s ease-in-out;
  animation: animate_xmark_icon 0.5s linear;
  /* color: red; */
}

.sidebar-1 {
  overflow: hidden;
  position: absolute;
  right: 5px;
  top: 65px;
  display: flex;
  height: auto;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  background-color: #2a4367;
  font-size: 3vmax;
  transition: 0.5s ease-in-out;
  z-index: 1;
  border-radius: 8px;
}


.sidebar-1 > a {
  width: 100%;
  padding: 0.5rem 0.8rem;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  transition: 0.2s ease-in-out;
  border-bottom: 1px solid whitesmoke ;
}
.sidebar-1 > a:hover {
  border-top: 1px solid whitesmoke ;

  background-color: #122b4f;
  /* font-weight: 800; */
  scale: 1.1;
}

/* ##### Code for CountryHeader2  --> Sidebar, Openbar,Closebar #####*/

.header-open-detail {
  position: relative;
  display: none;
  z-index: 1;
}

.header-open-detail > p {
  border: 2px solid rgb(82, 78, 78);
  border-radius: 4px;
  position: relative;
  z-index: 5;
}

.header-open-detail > p > i {
  cursor: pointer;
  font-size: 5vmin;
  font-weight: 700;
  color: rgb(230, 219, 219);
}

.sidebar-2 {
  position: absolute;
  right: 0.2rem;
  top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 0;
  transition: 0.5s ease-in-out;
  overflow: hidden;
}

.sidebar-2 > div {
  margin: 1.5vmin 0;
  position: relative;
  width: auto;
  transition: 0.5s ease-in-out;
}

.sidebar-2 > div > i {
  color: #122b4f;
  display: flex;
  align-items: center;
  justify-content: center;
  /* height: 6vmin;
  width: 6vmin; */
  margin: 1.5vmin 1vmin;
  font-size: 4vmin;
  border-radius: 50%;
  transition: 0.3s all;
}

.sidebar-2 > div > div {
  text-align: center;
  width: 150px;
  position: absolute;
  right: 100%;
  top: 20%;
  /* padding: 1vmin 1.5vmin; */
  /* box-shadow: 2px 2px 2px 1px rgb(88, 87, 87); */
  height: 0;
  overflow: hidden;
  transition: 0.5s ease-in-out;
  background: #fff;
  /* background: linear-gradient(to bottom,rgb(220, 215, 215),rgb(204, 199, 199)); */
}

.sidebar-2 > div > div > a {
  font-weight: 600;
  font-size: 2.5vmin;
  white-space: nowrap;
}

.sidebar-2 > div > div > select {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: none;
  font-weight: 600;
  font-size: 2vmin;
  outline: none;
}

.project-detail-container > p {
}

.project-detail-container > div > p {
  cursor: pointer;
  font-weight: 600;
  text-align: start;
  white-space: nowrap;
  font-size: 2.5vmin;
  padding: 1.5vmin;
}

.project-detail-container > div > :first-child,
.sp1,
.sp2 {
  background-color: rgb(228, 228, 224) !important;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2vmin;
  /* margin: 0 0.5vmin; */
}

.project-detail-container > div > :first-child > i {
  padding-right: 0.5vmin;
}

.project-detail-container > div > p:hover {
  background-color: rgba(25, 118, 210, 0.08) !important;
}

.project-detail-container > div > :first-child:hover {
  background-color: #ed7d31 !important;
  color: #fff !important;
}

.project-detail-container > div > div {
  /* height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: .5s ease-in-out; */
}

.project-detail-container > div,
.sp1,
.sp2 {
  border-bottom: 3px solid #fff;
}

.project-detail-container > :last-child {
  border-bottom: none !important;
}

.project-detail-container > div > :last-child {
  border: none;
}

.project-detail-container > div > div > p {
  padding: 0.5vmin 0;
}

.project-detail-container > div > p:hover {
  color: #2b4b79;
  color: #3a5a88;
}

.select > option {
  padding: 3vmin;
  margin: 3vmin;
  font-size: 3vmin;
}

/* ##### CountryHeader2  --> Dropdown #####*/

.SubHeader {
  background-color: rgb(228, 228, 224) !important;
  cursor: pointer;
  border-bottom: 3px solid #fff;
  word-wrap: nowrap;
  word-spacing: nowrap;
  word-break: nowrap;
}

.SubHeader > span {
  /* display: block; */
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  word-wrap: nowrap;
  word-spacing: nowrap;
  word-break: nowrap;
  white-space: nowrap;
}

.SubHeader:hover {
  background-color: rgb(233, 182, 116) !important;
}

.last_item {
  border-bottom: none;
}

.css-6hp17o-MuiList-root-MuiMenu-list {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}

.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper {
  scrollbar-width: 2px !important;
}

.css-mhc70k-MuiGrid-root > .MuiGrid-item {
  padding-top: 0 !important;
}

.css-6hp17o-MuiList-root-MuiMenu-list>:last-child,.css-6hp17o-MuiList-root-MuiMenu-list>:last-child{
  border-bottom: none;
}

/* ##### CountryHeader2  --> End #####*/

@media screen and (max-width: 950px) {
  .detail-link {
    display: none !important;
    background-color: #fff;
  }

  .header-open-detail {
    display: block;
  }
}

@media screen and (max-width: 750px) {
  .header > :last-child {
    display: none;
  }

  .bar {
    display: block;
  }

  .header > :nth-child(2) {
    font-size: 3vmin;
  }
}

@media screen and (max-width: 500px) {
}
`, "",{"version":3,"sources":["webpack://./src/modules/Headers/CountryHeader.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD,iCAAiC;AACjC;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,oCAAoC;AACtC;AACA;EACE,iCAAiC;;EAEjC,yBAAyB;EACzB,sBAAsB;EACtB,UAAU;AACZ;;AAEA,sEAAsE;;AAEtE;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;iBACe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,4BAA4B;EAC5B,iDAAiD;EACjD,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,kFAAkF;AACpF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;AACA;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,+CAA+C;;EAE/C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE;;;;;gCAK8B;AAChC;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA,4CAA4C;;AAE5C;EACE,+CAA+C;EAC/C,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uCAAuC;;AAEvC;EACE;IACE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;AACA","sourcesContent":["/* ##### Code for CounterHeader and CountryHeader2 #####*/\n\n/* ##### Header  --> Start #####*/\n.header {\n  height: 60px;\n  width: 100%;\n  position: sticky;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem;\n  background-color: #122b4f;\n  background-color: #203864;\n  z-index: 3;\n  transition: 0.3s ease-out;\n}\n.header > :first-child {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.header > :first-child > img {\n  max-height: 8vmin;\n  cursor: pointer;\n}\n.header > :nth-child(2) {\n  font-size: 3vmin;\n  font-weight: 900;\n  color: #fff;\n  width: 40%;\n  text-align: center;\n  padding: 1vmax;\n}\n\n.header > :last-child {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.8vmax;\n}\n\n.header > :last-child > span {\n  text-align: center;\n  font-weight: 900;\n  font-size: 2.2vmin;\n  cursor: pointer;\n  transition: 0.1s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 0.5vmax;\n  color: #fff;\n  white-space: nowrap;\n}\n.header > :last-child > span > svg {\n  padding-right: 0.5vmin;\n}\n\n.header > :last-child > span:hover {\n  color: #ed7d31 !important;\n}\n\n.dropdown {\n  padding: 0 0.2vmax;\n}\n\n.bar {\n  color: #fff;\n  display: none;\n  font-size: 1.8rem;\n  height: 40px ;\n  width: 40px;\n  text-align: center;\n}\n.bar i{\n  cursor: pointer;\n}\n\n.bar-icon {\n  /* margin-left: 130%; */\n  animation: animate_bar_icon 0.5s linear;\n  transition: 0.3s ease-in-out;\n}\n\n.xmark-icon {\n  transition: 0.3s ease-in-out;\n  animation: animate_xmark_icon 0.5s linear;\n  /* color: red; */\n}\n\n.sidebar-1 {\n  overflow: hidden;\n  position: absolute;\n  right: 5px;\n  top: 65px;\n  display: flex;\n  height: auto;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-evenly;\n  background-color: #2a4367;\n  font-size: 3vmax;\n  transition: 0.5s ease-in-out;\n  z-index: 1;\n  border-radius: 8px;\n}\n\n\n.sidebar-1 > a {\n  width: 100%;\n  padding: 0.5rem 0.8rem;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  transition: 0.2s ease-in-out;\n  border-bottom: 1px solid whitesmoke ;\n}\n.sidebar-1 > a:hover {\n  border-top: 1px solid whitesmoke ;\n\n  background-color: #122b4f;\n  /* font-weight: 800; */\n  scale: 1.1;\n}\n\n/* ##### Code for CountryHeader2  --> Sidebar, Openbar,Closebar #####*/\n\n.header-open-detail {\n  position: relative;\n  display: none;\n  z-index: 1;\n}\n\n.header-open-detail > p {\n  border: 2px solid rgb(82, 78, 78);\n  border-radius: 4px;\n  position: relative;\n  z-index: 5;\n}\n\n.header-open-detail > p > i {\n  cursor: pointer;\n  font-size: 5vmin;\n  font-weight: 700;\n  color: rgb(230, 219, 219);\n}\n\n.sidebar-2 {\n  position: absolute;\n  right: 0.2rem;\n  top: 60px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 0;\n  transition: 0.5s ease-in-out;\n  overflow: hidden;\n}\n\n.sidebar-2 > div {\n  margin: 1.5vmin 0;\n  position: relative;\n  width: auto;\n  transition: 0.5s ease-in-out;\n}\n\n.sidebar-2 > div > i {\n  color: #122b4f;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* height: 6vmin;\n  width: 6vmin; */\n  margin: 1.5vmin 1vmin;\n  font-size: 4vmin;\n  border-radius: 50%;\n  transition: 0.3s all;\n}\n\n.sidebar-2 > div > div {\n  text-align: center;\n  width: 150px;\n  position: absolute;\n  right: 100%;\n  top: 20%;\n  /* padding: 1vmin 1.5vmin; */\n  /* box-shadow: 2px 2px 2px 1px rgb(88, 87, 87); */\n  height: 0;\n  overflow: hidden;\n  transition: 0.5s ease-in-out;\n  background: #fff;\n  /* background: linear-gradient(to bottom,rgb(220, 215, 215),rgb(204, 199, 199)); */\n}\n\n.sidebar-2 > div > div > a {\n  font-weight: 600;\n  font-size: 2.5vmin;\n  white-space: nowrap;\n}\n\n.sidebar-2 > div > div > select {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  border: none;\n  font-weight: 600;\n  font-size: 2vmin;\n  outline: none;\n}\n\n.project-detail-container > p {\n}\n\n.project-detail-container > div > p {\n  cursor: pointer;\n  font-weight: 600;\n  text-align: start;\n  white-space: nowrap;\n  font-size: 2.5vmin;\n  padding: 1.5vmin;\n}\n\n.project-detail-container > div > :first-child,\n.sp1,\n.sp2 {\n  background-color: rgb(228, 228, 224) !important;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 2vmin;\n  /* margin: 0 0.5vmin; */\n}\n\n.project-detail-container > div > :first-child > i {\n  padding-right: 0.5vmin;\n}\n\n.project-detail-container > div > p:hover {\n  background-color: rgba(25, 118, 210, 0.08) !important;\n}\n\n.project-detail-container > div > :first-child:hover {\n  background-color: #ed7d31 !important;\n  color: #fff !important;\n}\n\n.project-detail-container > div > div {\n  /* height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: .5s ease-in-out; */\n}\n\n.project-detail-container > div,\n.sp1,\n.sp2 {\n  border-bottom: 3px solid #fff;\n}\n\n.project-detail-container > :last-child {\n  border-bottom: none !important;\n}\n\n.project-detail-container > div > :last-child {\n  border: none;\n}\n\n.project-detail-container > div > div > p {\n  padding: 0.5vmin 0;\n}\n\n.project-detail-container > div > p:hover {\n  color: #2b4b79;\n  color: #3a5a88;\n}\n\n.select > option {\n  padding: 3vmin;\n  margin: 3vmin;\n  font-size: 3vmin;\n}\n\n/* ##### CountryHeader2  --> Dropdown #####*/\n\n.SubHeader {\n  background-color: rgb(228, 228, 224) !important;\n  cursor: pointer;\n  border-bottom: 3px solid #fff;\n  word-wrap: nowrap;\n  word-spacing: nowrap;\n  word-break: nowrap;\n}\n\n.SubHeader > span {\n  /* display: block; */\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 2rem;\n  word-wrap: nowrap;\n  word-spacing: nowrap;\n  word-break: nowrap;\n  white-space: nowrap;\n}\n\n.SubHeader:hover {\n  background-color: rgb(233, 182, 116) !important;\n}\n\n.last_item {\n  border-bottom: none;\n}\n\n.css-6hp17o-MuiList-root-MuiMenu-list {\n  padding-bottom: 0 !important;\n  padding-top: 0 !important;\n}\n\n.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper {\n  scrollbar-width: 2px !important;\n}\n\n.css-mhc70k-MuiGrid-root > .MuiGrid-item {\n  padding-top: 0 !important;\n}\n\n.css-6hp17o-MuiList-root-MuiMenu-list>:last-child,.css-6hp17o-MuiList-root-MuiMenu-list>:last-child{\n  border-bottom: none;\n}\n\n/* ##### CountryHeader2  --> End #####*/\n\n@media screen and (max-width: 950px) {\n  .detail-link {\n    display: none !important;\n    background-color: #fff;\n  }\n\n  .header-open-detail {\n    display: block;\n  }\n}\n\n@media screen and (max-width: 750px) {\n  .header > :last-child {\n    display: none;\n  }\n\n  .bar {\n    display: block;\n  }\n\n  .header > :nth-child(2) {\n    font-size: 3vmin;\n  }\n}\n\n@media screen and (max-width: 500px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
